/* Titta · Producto estándar — selector de variantes (solo stock), precio dinámico y compra AJAX */
(function () {
  'use strict';

  function money(cents, fmt) {
    var s = (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (fmt && fmt.indexOf('{{') > -1) return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, s);
    return '$' + s;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }


  var SIZE_RANK = ['XXS','XS','S','M','L','XL','XXL','2XL','XXXL','3XL'];
  function sizeRank(v) { var k = String(v).trim().toUpperCase().split(/[\s(\/]/)[0]; var i = SIZE_RANK.indexOf(k); return i < 0 ? 99 : i; }
  function sortSizes(vals) {
    if (!vals.every(function (v) { return sizeRank(v) < 99; })) return vals;
    return vals.slice().sort(function (a, b) { return sizeRank(a) - sizeRank(b); });
  }
  function init(sec) {
    var picker = sec.querySelector('[data-tp-picker]');
    var buy = sec.querySelector('[data-tp-buy]');
    if (!picker || picker.dataset.tpInit) return;
    picker.dataset.tpInit = '1';
    var cfg = JSON.parse(picker.querySelector('[data-tp-json]').textContent);
    var V = cfg.variants, N = cfg.options.length, fmt = cfg.moneyFormat;
    var hex = {};
    (cfg.colorHex || '').split(/\n/).forEach(function (l) { var i = l.lastIndexOf(':'); if (i > 0) hex[l.slice(0, i).trim().toLowerCase()] = l.slice(i + 1).trim(); });
    var isColor = cfg.options.map(function (n) { var l = String(n).toLowerCase(); return cfg.colorWords.some(function (w) { return l.indexOf(w) > -1; }); });

    var cur = V.filter(function (v) { return v.id === cfg.selected; })[0] || V.filter(function (v) { return v.available; })[0] || V[0];
    var sel = cur.o.slice(0, N);

    function match(v, upto) { for (var k = 0; k < upto; k++) if (v.o[k] !== sel[k]) return false; return true; }
    function valuesFor(i) {
      var out = [];
      V.forEach(function (v) { if (v.available && match(v, i) && out.indexOf(v.o[i]) < 0) out.push(v.o[i]); });
      return out;
    }
    function imgFor(i, val) {
      for (var k = 0; k < V.length; k++) if (V[k].o[i] === val && V[k].img && match(V[k], i)) return V[k].img;
      for (k = 0; k < V.length; k++) if (V[k].o[i] === val && V[k].img) return V[k].img;
      return null;
    }
    function resolve() {
      for (var i = 0; i < N; i++) {
        var vals = valuesFor(i);
        if (vals.length && vals.indexOf(sel[i]) < 0) sel[i] = vals[0];
      }
      var f = V.filter(function (v) { return v.available && match(v, N); })[0];
      cur = f || V.filter(function (v) { return match(v, N); })[0] || cur;
    }

    var $ = function (s, r) { return (r || sec).querySelector(s); };
    var elNow = $('[data-tp-price-now]'), elWas = $('[data-tp-price-was]'), elSave = $('[data-tp-save]'),
        elStock = $('[data-tp-stock]'), btn = buy && $('[data-tp-add]', buy), lbl = buy && $('[data-tp-add-label]', buy),
        msgEl = buy && $('[data-tp-msg]', buy), qtyIn = buy && $('[data-tp-qty-input]', buy),
        stPrice = buy && $('[data-tp-sticky-price]', buy), stVar = buy && $('[data-tp-sticky-var]', buy);

    function msg(t, err) { if (!msgEl) return; if (!t) { msgEl.hidden = true; return; } msgEl.hidden = false; msgEl.textContent = t; msgEl.classList.toggle('is-error', !!err); }

    function renderOptions() {
      sec.querySelectorAll('[data-tp-opt]').forEach(function (box) {
        var i = +box.dataset.tpOpt, wrap = box.querySelector('[data-tp-values]'), vals = isColor[i] ? valuesFor(i) : sortSizes(valuesFor(i));
        box.querySelector('[data-tp-optval]').textContent = sel[i] || '';
        wrap.innerHTML = '';
        var swOk = isColor[i] && vals.every(function (val) { return imgFor(i, val) || hex[String(val).toLowerCase()]; });
        wrap.classList.toggle('is-swatch', swOk);
        vals.forEach(function (val) {
          var b = document.createElement('button');
          b.type = 'button'; b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', val === sel[i] ? 'true' : 'false');
          b.title = val; b.setAttribute('aria-label', cfg.options[i] + ': ' + val);
          if (swOk) {
            b.className = 'titta-color titta-vp__sw' + (val === sel[i] ? ' is-picked' : '');
            var im = imgFor(i, val), hx = hex[String(val).toLowerCase()];
            if (im) b.style.backgroundImage = 'url("' + im + '")'; else if (hx) b.style.backgroundColor = hx; else { b.className = 'titta-size'; b.textContent = val; }
          } else {
            b.className = 'titta-size'; b.textContent = val;
          }
          b.addEventListener('click', function () { sel[i] = val; resolve(); render(true); });
          wrap.appendChild(b);
        });
      });
    }

    function render(userChange) {
      renderOptions();
      if (elNow) elNow.textContent = money(cur.price, fmt);
      var onSale = cur.compare > cur.price;
      if (elWas) { elWas.hidden = !onSale; elWas.textContent = money(cur.compare, fmt); }
      if (elSave) {
        elSave.hidden = !onSale;
        if (onSale) elSave.textContent = 'Ahorras ' + money(cur.compare - cur.price, fmt) + ' (' + Math.round((cur.compare - cur.price) * 100 / cur.compare) + '%)';
      }
      if (elStock) {
        var left = cur.stock;
        elStock.hidden = !(cur.available && left > 0 && left <= 3);
        elStock.innerHTML = '🔥 ¡Quedan solo <strong>' + left + '</strong> ' + (left === 1 ? 'unidad' : 'unidades') + ' en esta talla y color!';
      }
      if (btn) {
        btn.disabled = !cur.available;
        if (cur.available) lbl.innerHTML = 'Agregar al carrito<span class="titta-cta-sep"> · </span><span class="titta-cta-price">' + money(cur.price * (+qtyIn.value || 1), fmt) + '</span>'; else lbl.textContent = 'Agotado';
      }
      if (stPrice) stPrice.textContent = money(cur.price, fmt);
      if (stVar) stVar.textContent = sel.filter(Boolean).join(' / ');
      var sb = buy && buy.querySelector('[data-sticky-btn]'); if (sb) { sb.disabled = !cur.available; sb.textContent = cur.available ? 'Agregar al carrito' : 'Agotado'; }
      var addi = document.querySelector('addi-product-widget'); if (addi) addi.setAttribute('price', String(cur.price / 100));
      if (userChange) {
        try { var u = new URL(location.href); u.searchParams.set('variant', cur.id); history.replaceState(null, '', u.toString()); } catch (e) {}
        if (cur.media) {
          var slide = sec.querySelector('[data-media-id="' + cur.media + '"]'), track = sec.querySelector('[data-gal-track]');
          if (slide && track) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
        msg('');
      }
    }

    if (buy) {
      buy.querySelectorAll('[data-tp-qty]').forEach(function (b) {
        b.addEventListener('click', function () { qtyIn.value = Math.max(1, (+qtyIn.value || 1) + (+b.dataset.tpQty)); render(false); });
      });
      qtyIn.addEventListener('change', function () { qtyIn.value = Math.max(1, +qtyIn.value || 1); render(false); });
      btn.addEventListener('click', function () {
        if (!cur.available) return;
        var q = Math.max(1, +qtyIn.value || 1);
        btn.classList.add('is-loading'); lbl.textContent = 'Agregando…'; msg('');
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: cur.id, quantity: q }] }) })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            btn.classList.remove('is-loading');
            if (!res.ok) { msg(res.d.description || res.d.message || 'No pudimos agregar el producto. Intenta de nuevo.', true); render(false); return; }
            lbl.textContent = '¡Listo! Agregado';
            var product = res.d.items ? res.d.items[0] : res.d;
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: product, addToCartBtn: btn } }));
            if (window.theme && theme.settings && theme.settings.cartType === 'page') location.href = root + 'cart';
            setTimeout(function () { render(false); }, 2200);
          })
          .catch(function () { btn.classList.remove('is-loading'); msg('Error de conexión. Intenta de nuevo.', true); render(false); });
      });
      var sticky = buy.querySelector('[data-sticky]'), sBtn = buy.querySelector('[data-sticky-btn]');
      if (sticky && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0], show = !e.isIntersecting && e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        }).observe(btn);
        sBtn.addEventListener('click', function () {
          btn.click();
        });
      }
    }

    var dlg = picker.querySelector('[data-size-dialog]'), op = picker.querySelector('[data-size-open]'), cl = picker.querySelector('[data-size-close]');
    if (dlg && op) {
      op.addEventListener('click', function () { dlg.showModal ? dlg.showModal() : dlg.setAttribute('open', ''); });
      cl.addEventListener('click', function () { dlg.close ? dlg.close() : dlg.removeAttribute('open'); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    }

    resolve();
    render(false);
  }

  function boot(scope) { (scope || document).querySelectorAll('.titta-pack').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
